module.exports = __webpack_public_path__ + "static/img/how1.192fe082.png";